import React from 'react'
import { withRouter } from 'react-router'
import { setActiveTab } from 'ducks/editor/tabs'
import { useDispatch, useSelector } from 'react-redux'
import { getThirdPartyApiKeyFor } from 'ducks/thirdPartyApiKeys'
import { getActiveModal } from 'ducks/editor/modals'

import Tooltip from '../Tooltip'
import Icon from '../Icon'

import './GoogleHelpLink.scss'

const LinkText = ({ isInvalid }) => {
  if (isInvalid) {
    return (
      <>
        The&nbsp;<strong className="help-link__link">provided</strong>
        &nbsp;Google API key is invalid.
      </>
    )
  }

  return (
    <>
      <strong className="help-link__link">Add&nbsp;</strong>a Google API Key
    </>
  )
}

const TooltipText = ({ isInvalid, onClick }) => {
  if (isInvalid) {
    return (
      <p>
        Your{' '}
        <span className="tooltip-link" onClick={onClick}>
          Google API key
        </span>{' '}
        is invalid.
      </p>
    )
  }

  return (
    <p>
      Add your Google API key{' '}
      <span className="tooltip-link" onClick={onClick}>
        here
      </span>
      .
    </p>
  )
}

const HelpLink = ({ history, isError, match, isTooltip, children }) => {
  const { appId } = match.params

  const googleApiKey = useSelector(state =>
    getThirdPartyApiKeyFor(state, appId, 'google')
  )

  const dispatch = useDispatch()
  const activeModal = useSelector(getActiveModal)

  if (googleApiKey?.isValid) {
    return null
  }

  const isInvalid = googleApiKey && !googleApiKey.isValid

  const onClick = () => {
    if (activeModal) {
      activeModal.reject()
    }

    dispatch(setActiveTab('settings'))
    history.push(`/apps/${appId}/app-settings?active=apikeys`)
  }

  if (isTooltip) {
    return <TooltipText onClick={onClick} isInvalid={isInvalid} />
  }

  return (
    <p
      onClick={onClick}
      className={`help-link ${isError ? 'help-link--error' : ''}`}
    >
      {children || <LinkText isInvalid={isInvalid} />}
    </p>
  )
}

const WrappedHelpLink = withRouter(HelpLink)

export const GoogleTooltip = (
  <Tooltip tooltip={<WrappedHelpLink isTooltip />}>
    <Icon type="warning" small />
  </Tooltip>
)

export default WrappedHelpLink
